import {createPrimitiveAtom} from '@reatom/core/primitives'
import {TypedHistory} from '../routes/types'

export const historyAtom = createPrimitiveAtom<TypedHistory>({} as TypedHistory)
